import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppDataService } from './app-data.service';

@Injectable()
export class RestInterceptor implements HttpInterceptor {
  constructor(private appDataService: AppDataService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Intercept only the calls to the backend service
    if (req.url.indexOf('w4/api') > 0) {
      const authRequest = req.clone({
        headers: req.headers.set('Authorization', 'Token ' + this.appDataService.getUserToken()),
      });
      return next.handle(authRequest);
    } else {
      return next.handle(req);
    }
  }
}
